import { createGlobalStyle } from 'styled-components';

export const GlobalCss = createGlobalStyle`
    html {
        box-sizing: border-box;
        width: 100%;
        height: 100vh;
        height: 100svh;
        overflow: hidden;
    }

    *,
    *:before,
    *:after {
        box-sizing: inherit;
    }

    body {
        -webkit-font-smoothing: antialiased;
        word-break: break-word;
        margin: 0 auto;
        padding: 0;
        position: relative;
        background-color: #000;
    }
`;
